import { $http } from '@/api/common/Axios';
import { ImageFileDTO } from '@/api/dto/ImageFileDTO';

export class UploadEndpoints {
  public async uploadImage(image: File): Promise<ImageFileDTO> {
    const formData = new FormData();
    formData.append('UploadFile', image);
    const response = await $http.post(`/imageupload`, formData);
    return response?.data;
  }
}
